export default "__VITE_ASSET__Cnnmlm$K__"